import QuantumToken from './QuantumToken.json';

const contract = require('@truffle/contract');

export default contract({
  abi: QuantumToken.abi,
});
